import { getCategoryHref } from '../../utils/common/category';
import {
  PARAGRAPH_GENERATOR_CATEGORY,
  INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY,
  BODY_PARAGRAPH_GENERATOR_CATEGORY,
  CONCLUSION_PARAGRAPH_GENERATOR_CATEGORY,
} from '../../constants';

const chipValues = [
  {
    title: 'All',
    value: getCategoryHref(PARAGRAPH_GENERATOR_CATEGORY),
  },
  {
    title: 'Introduction',
    value: getCategoryHref(INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY),
  },
  {
    title: 'Body',
    value: getCategoryHref(BODY_PARAGRAPH_GENERATOR_CATEGORY),
  },
  {
    title: 'Conclusion',
    value: getCategoryHref(CONCLUSION_PARAGRAPH_GENERATOR_CATEGORY),
  },
];

export { chipValues };
